import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "-4.5 -4.5 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.25 6.75H15V8.25H8.25V15H6.75V8.25H0V6.75H6.75V0H8.25V6.75Z", fill: "currentColor" }));
export default SvgPlus;
